import React from 'react';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import { LinkField, useFieldHelper } from 'framework/ui/field';

type StructureCreatedListLinkFieldProps = {
  id: string;
  createdAt: string;
  label: string;
  width: string;
};
const StructureCreatedListLinkField = ({ createdAt, id, label, width }: StructureCreatedListLinkFieldProps) => {
  const { formatDate } = useDateService();
  const { getValue: getStartDate } = useFieldHelper({ source: createdAt });

  return (
    <LinkField
      width={width}
      label={label}
      source={createdAt}
      linkText={`${formatDate(getStartDate(), DATE_FORMAT.FULL_WITH_TIMEZONE)}`}
      linkSource={id}
    />
  );
};
export default StructureCreatedListLinkField;
